var productSizeGuideDrawer = (function () {
  var _currentUnit = 'inch';

  function _moveToBody() {
    var drawer  = document.getElementById('sg-drawer');
    var overlay = document.getElementById('sg-drawer-overlay');
    if (drawer  && drawer.parentNode  !== document.body) document.body.appendChild(drawer);
    if (overlay && overlay.parentNode !== document.body) document.body.appendChild(overlay);
  }

  function open(genderHint) {
    _moveToBody();
    var drawer  = document.getElementById('sg-drawer');
    var overlay = document.getElementById('sg-drawer-overlay');
    if (!drawer || !overlay) return;
    var genderInput = document.querySelector('input[name="product-option-Gender"]:checked') ||
                      document.querySelector('input[name="product-option-gender"]:checked');
    var gender = genderInput ? genderInput.value.toLowerCase() : (genderHint || '');
    if (gender) switchGender(gender);
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
  }

  function close() {
    var drawer  = document.getElementById('sg-drawer');
    var overlay = document.getElementById('sg-drawer-overlay');
    if (drawer)  drawer.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
  }

  function switchGender(gender) {
    gender = gender.toLowerCase();
    var tabs     = document.querySelectorAll('#sg-drawer .sg-gender-tab');
    var contents = document.querySelectorAll('#sg-drawer .sg-gender-content');
    var matched  = false;
    tabs.forEach(function (el) {
      var isMatch = el.dataset.gender === gender;
      el.classList.toggle('active', isMatch);
      if (isMatch) matched = true;
    });
    contents.forEach(function (el) {
      el.style.display = el.dataset.genderContent === gender ? '' : 'none';
    });
    if (!matched && tabs.length > 0) {
      var firstGender = tabs[0].dataset.gender;
      tabs[0].classList.add('active');
      contents.forEach(function (el) {
        el.style.display = el.dataset.genderContent === firstGender ? '' : 'none';
      });
    }
  }

  function switchTab(tab) {
    document.querySelectorAll('#sg-drawer .sg-tab').forEach(function (el) {
      var isActive = el.dataset.tab === tab;
      el.classList.toggle('active', isActive);
      el.classList.toggle('bold-700', isActive);
    });
    document.querySelectorAll('#sg-drawer .sg-tab-content').forEach(function (el) {
      el.style.display = el.dataset.tabContent === tab ? '' : 'none';
    });
  }

  function setUnit(unit) {
    _currentUnit = unit;
    document.querySelectorAll('#sg-drawer .sg-unit-btn').forEach(function (el) {
      el.classList.toggle('active', el.dataset.unit === unit);
    });
    document.querySelectorAll('#sg-drawer .sg-unit-content').forEach(function (el) {
      el.style.display = el.dataset.unitContent === unit ? '' : 'none';
    });
    var label = document.querySelector('#sg-drawer .label-switch');
    if (label) {
      label.classList.toggle('cm',   unit === 'cm');
      label.classList.toggle('inch', unit === 'inch');
    }
  }

  function toggleUnit() {
    setUnit(_currentUnit === 'inch' ? 'cm' : 'inch');
  }

  document.addEventListener('DOMContentLoaded', function () {
    _moveToBody();
  });

  return { open: open, close: close, switchTab: switchTab, switchGender: switchGender, setUnit: setUnit, toggleUnit: toggleUnit };
})();
